import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["FaviconSync","LandingFaqRow"] */ "D:\\b\\baczonedz\\src\\components\\landing\\landing-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicHeader"] */ "D:\\b\\baczonedz\\src\\components\\public-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicRootRedirect"] */ "D:\\b\\baczonedz\\src\\components\\ui\\public-root-redirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "D:\\b\\baczonedz\\src\\components\\ui\\site-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarScript"] */ "D:\\b\\baczonedz\\src\\features\\sidebar\\sidebar-script.tsx");
